import React from "react";
import { makeStyles } from '@material-ui/core/styles';

import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import Tooltip from '@material-ui/core/Tooltip';

import BoldIcon from '@material-ui/icons/FormatBold';
import ItalicIcon from '@material-ui/icons/FormatItalic';
import UnderlineIcon from '@material-ui/icons/FormatUnderlined';
import StrikethroughIcon from '@material-ui/icons/FormatStrikethrough';

const useStyles = makeStyles(theme => ({
    active: {
        backgroundColor: 'rgba(0, 0, 0, 0.10);',
        "&:hover" : {
            backgroundColor: 'background-color: rgba(0, 0, 0, 0.10);',
        }
    },
}));

const INLINE_STYLES = [
    { id: "bold", icon: <BoldIcon />, style: "BOLD", label: "Bold" },
    { id: "italic", icon: <ItalicIcon />, style: "ITALIC", label: "Italic" },
    { id: "underline", icon: <UnderlineIcon />, style: "UNDERLINE", label: "Underline" },
    { id: "strikethrough", icon: <StrikethroughIcon />, style: "STRIKETHROUGH", label: "Strikethrough" }
];

export default function InlineStyle(props) {

    const classes = useStyles();

    const { editorState, onToggle } = props;

    const currentStyle = editorState.getCurrentInlineStyle();

    const onClick = (event, style) => {
        event.preventDefault();
        onToggle(style);
    }

    return (
        <ButtonGroup>
            {INLINE_STYLES.map((type, i) => (
                <Tooltip title={type.label} key={i}>
                    <Button
                        id={type.id}
                        size="small"
                        className={currentStyle.has(type.style) ? classes.active : null}
                        onMouseDown={(event) => onClick(event, type.style)}
                        >
                        {type.icon}
                    </Button>
                </Tooltip>
            ))}
        </ButtonGroup>
    );
}
